import React, { useState, useEffect, useRef } from "react"; // add useRef
import PropTypes from "prop-types";
import axios from "axios";
import { Link } from 'react-router-dom';
import { useHistory, useLocation } from "react-router-dom";
import "./Header.css";
import "../../assets/css/component.css";
import { TiHome } from "react-icons/ti";
import { ButtonGroup, Dropdown } from "react-bootstrap";
import { defaultParam, defaultParams } from "./defaultParams";
import CartIcon from "../../assets/icons/cart-icon.svg.jsx";
import logout from "../../assets/svgs/log-out.svg";
import user from "../../assets/svgs/user.svg";
import logo from "../../assets/svgs/logo.svg";
import "../../assets/css/modal.css";
import Step1 from "../Modals/Step1";
import PopUp from "../Modals/Popup";
import Step2 from "../Modals/Step2";
import Step3 from "../Modals/Step3";
import Signup from "../Signup/Signup";
import Signup2 from "../Signup/Signup2";
import VerifiedEmail from "../Modals/VerifiedEmail";

import { loginUser, logoutUser, ClearState, locationLabel } from "../../actions/authActions";

import { mycart, cartLocal } from "../../actions/productActions";
import Spinner from "../../common/Spinner";
import { connect, useSelector } from "react-redux";
import { withTranslation } from "react-i18next";
import TrackOrder from "../TrackOrder/TrackOrder";
import TrackOrderNow from "../TrackOrderNow/TrackOrderNow";
import MenuModal from "../Menu/MenuModal";
import { RiArrowDropDownFill, RiArrowDropUpFill } from "react-icons/ri";
import { FiLogOut } from "react-icons/fi";
import { MdAccountCircle } from "react-icons/md";
import { FaTruck } from "react-icons/fa";
import { BiReceipt } from "react-icons/bi";
import { FaHome } from "react-icons/fa";
const Header = (props) => {
  const [mobileDropdown, setMobileDropdown] = useState(false);
  const [showLogoutConfirm, setShowLogoutConfirm] = useState(false);
  const [showDropdown, setShowDropdown] = useState(false);
  const [activeNavItem, setActiveNavItem] = useState('home');
  const [selectedIndex, setSelectedIndex] = useState(null);
  const [scrolled, setScrolled] = useState(false);

  /* get parameter values from URL - start */
  const currentPath = useLocation(); // get current url path
  const queryParams = new URLSearchParams(window.location.search);
  let business_id = queryParams.get('business_id');
  let location_id = queryParams.get('location_id');
  if (currentPath.pathname === '/') {

    if (localStorage.getItem("location_id") && localStorage.getItem("business_id")) {
      if (queryParams.get('business_id') !== localStorage.getItem('business_id') || queryParams.get('location_id') !== localStorage.getItem('location_id')) { //CLEAR CART IF DIFFERENT LOCATION/BUSINESS ID
        localStorage.removeItem("cart")
        localStorage.removeItem("deliveryInformation")
        localStorage.removeItem("out_name")
        localStorage.removeItem("paynow_number")
        localStorage.removeItem("amount_rounding_method")
      }
    }
    const verifiedEmail = queryParams.get('verifiedEmail');

    if ((business_id !== null || location_id !== null)) {
      localStorage.removeItem('business_id');
      localStorage.removeItem('location_id');
      localStorage.setItem('business_id', business_id);
      localStorage.setItem('location_id', location_id);
    }


    if (verifiedEmail) {
      localStorage.setItem('verifiedEmail', verifiedEmail);
    }
    else {
      if (localStorage.verifiedEmail) {
        localStorage.removeItem('verifiedEmail');
      }
    }
  }
  /* get parameter values from URL - end */

  const history = useHistory();
  const [show, setShow] = useState(null);
  const [isLoggedIn, setLogin] = useState(false);
  const [signup, setSignup] = useState(null);
  const [signInVal, setSignInVal] = useState(null);
  const [signupVal, setSignupVal] = useState(defaultParams);
  const [popupText, setPopupText] = useState("");
  const [lshow, setLshow] = useState(false);
  const [showVerifiedEmail, setShowVerifiedEmail] = useState(false);
  const [loaded, setLoading] = useState(false);
  const [clLogin, setClogin] = useState(false);
  const [load, setLoad] = useState(false);
  const [name, setUser] = useState(null);
  const [photo, setPhoto] = useState("");
  const photoRequest = useRef(null);
  const [cartData, setCartData] = useState(null);
  const [showtrackOrder, setShowTrackOrder] = useState(false);
  const [showTrackNow, setShowTracknow] = useState(false);
  const [showMenu, setShowMenu] = useState(false);
  const all_locations = useSelector((state) => (state?.auth?.all_locations));
  const location_label = useSelector((state) => (state?.auth?.location_label));

  // Read the signed-in user's display name out of the stored session.
  const showLoggedInUser = () => {
    if (!localStorage.headers) return;
    try {
      var name = JSON.parse(localStorage.getItem("headers"));
      var loggedUser = name && name.data && name.data.user;
      if (!loggedUser) return;
      var newname = loggedUser.fname + " " + (loggedUser.lname !== null && loggedUser.lname !== undefined ? loggedUser.lname : '');
      setUser(newname);
      refreshProfilePhoto();
    } catch (error) {
      console.warn('Unable to read stored session', error);
    }
  };

  // Profile photo comes from /auth/customer_profile; its URL is cached in the stored
  // session. Fetches when the session has no cached URL yet, or when `force` is set.
  const refreshProfilePhoto = (force) => {
    var session;
    try {
      session = JSON.parse(localStorage.getItem("headers"));
    } catch (error) {
      return;
    }
    var loggedUser = session && session.data && session.data.user;
    if (!loggedUser) return;
    setPhoto(loggedUser.profile_image_url || "");

    if ((!force && "profile_image_url" in loggedUser) || photoRequest.current) return;
    photoRequest.current = axios.get("/auth/customer_profile")
      .then((res) => {
        var profile = res.data || {};
        var latest = JSON.parse(localStorage.getItem("headers"));
        var latestUser = latest && latest.data && latest.data.user;
        // Skip if the user logged out or switched accounts while this was in flight
        if (!latestUser || String(latestUser.user_id) !== String(profile.id)) return;
        var url = profile.profile_image_url || null;
        if (latestUser.profile_image_url !== url) {
          latestUser.profile_image_url = url;
          localStorage.setItem("headers", JSON.stringify(latest));
        }
        setPhoto(url || "");
      })
      .catch(() => { })
      .finally(() => {
        photoRequest.current = null;
      });
  };

  // Show the "welcome back" popup once, as soon as the login is complete.
  const showWelcomePopup = () => {
    if (localStorage.popup && localStorage.login) {
      if (!props.signup_login) {
        setShowMenu(true);
      }
      localStorage.removeItem("popup");
    }
  };

  const loginInfo = () => {
    try {
      if (localStorage.login) {
        setLogin(true);
        setLoad(true);
        showLoggedInUser();
        if (localStorage.cart) {
          var data = JSON.parse(localStorage.getItem("cart"));
          props.cartLocal(data);
        }
      } else {
        if (localStorage.cart) {
          var datas = JSON.parse(localStorage.getItem("cart"));
          setLoad(true);
          props.cartLocal(datas);
        }
      }
      showWelcomePopup();

      if (!props.loading && props.add_to_cart !== null && loaded) {
        props.updateCart(props.add_to_cart);
        setCartData(props.add_to_cart);
        if (loaded) {
          console.log("reload");
          localStorage.setItem("popup", true);
          window.location.reload();
        }
      }

      if (localStorage.verifiedEmail) {
        setShowVerifiedEmail(true);
      }
    } catch (error) {
      throw error;
    }
  }

  useEffect(() => {
    setCartData(JSON.parse(localStorage.getItem("cart")));
    if (!props.loading && !props.auth.isAuthenticated && clLogin) {
      setClogin(false);
      setLshow(true);
    } else if (props?.signup_login || props.auth.user?.is_otp_verified || (clLogin && !props.loading && props.auth.isAuthenticated)) {
      setLogin(true);
      setClogin(false);
      localStorage.setItem("login", true);
      localStorage.setItem("popup", true);

      // `loginInfo()` is skipped once a cart exists (`load` is already true), so the
      // name and the welcome popup have to be refreshed here as well - otherwise the
      // header only catches up on the next page refresh.
      showLoggedInUser();
      showWelcomePopup();

      setLshow(false);
      setShow(null);

      if (localStorage.cart) {
        var datas = JSON.parse(localStorage.getItem("cart"));
        setLoad(true);
        props.cartLocal(datas);
      }
      setLoading(true);
    }
    if (localStorage.order_id && props.auth.isAuthenticated) {
      console.log("Show track order");
    }

    if (!load) {
      loginInfo();
    }

  }, [clLogin, history, load, loaded, props, props?.auth?.user?.is_otp_verified]);

  // Listen for a global event so other components can open header modals (Step1/Step2/Step3)
  useEffect(() => {
    const openHandler = (e) => {
      try {
        const step = e && e.detail && e.detail.step;
        if (typeof step !== 'undefined') {
          console.log('Header: openHeaderStep received, step=', step, 'current show=', show);
          setShow(step);
        }
      } catch (err) {
        console.error('openHeaderStep handler error', err);
      }
    };

    window.addEventListener('openHeaderStep', openHandler);
    return () => window.removeEventListener('openHeaderStep', openHandler);
  }, []);

  // The Account page fires this after saving a new name or photo to the stored session.
  useEffect(() => {
    window.addEventListener('profileUpdated', showLoggedInUser);
    return () => window.removeEventListener('profileUpdated', showLoggedInUser);
  }, []);

  // Recheck the photo when the tab regains focus so a change made elsewhere shows up.
  useEffect(() => {
    const onFocus = () => {
      if (localStorage.login && localStorage.headers) refreshProfilePhoto(true);
    };
    window.addEventListener('focus', onFocus);
    return () => window.removeEventListener('focus', onFocus);
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 20) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    loginInfo();
  }, [props?.auth?.user?.data?.is_register]);

  // Safety net: whenever a session exists, keep the header showing the logged-in
  // user. Read-only - it never writes the session flags itself.
  useEffect(() => {
    if (localStorage.login && localStorage.headers) {
      setLogin(true);
      showLoggedInUser();
    }
  }, [props?.auth?.isAuthenticated]);

  const cartIcon = document.querySelector(".cart-icon");

  const cartIconRef = useRef(null);

  const flyToCart = (imgRef) => {
    if (!imgRef?.current) return;

    const img = imgRef.current;

    const cartIcon = document.querySelector(
      window.innerWidth < 768 ? ".mycart-mb .mobile-cart-icon" : ".right-section .cart-icon"
    );
    if (!cartIcon) return;

    const imgRect = img.getBoundingClientRect();
    const cartRect = cartIcon.getBoundingClientRect();
    const flyingImg = img.cloneNode(true);
    flyingImg.style.position = "fixed";
    flyingImg.style.left = imgRect.left + "px";
    flyingImg.style.top = imgRect.top + "px";
    flyingImg.style.width = imgRect.width + "px";
    flyingImg.style.height = imgRect.height + "px";
    flyingImg.style.transition = "all 0.9s cubic-bezier(0.25, 1, 0.5, 1)";
    flyingImg.style.zIndex = 9999;
    flyingImg.style.pointerEvents = "none";
    flyingImg.style.borderRadius = "8px";

    document.body.appendChild(flyingImg);

    // Animate toward cart
    requestAnimationFrame(() => {
      flyingImg.style.left = cartRect.left + "px";
      flyingImg.style.top = cartRect.top + "px";
      flyingImg.style.width = "35px";
      flyingImg.style.height = "35px";
      flyingImg.style.opacity = 0.4;
      flyingImg.style.transform = "scale(0.5)";
      flyingImg.style.borderRadius = "50%";
    });

    // Clean up
    flyingImg.addEventListener("transitionend", () => {
      flyingImg.remove();
      cartIcon.classList.add("wobble");
      setTimeout(() => cartIcon.classList.remove("wobble"), 600);

      // Also wobble the bottom nav cart inner icon
      const bottomNavCart = document.querySelector(".bottom-nav-cart-icon .nav-cart-inner");
      if (bottomNavCart) {
        bottomNavCart.classList.add("wobble");
        setTimeout(() => bottomNavCart.classList.remove("wobble"), 600);
      }
    });
  };

  window.flyToCart = flyToCart;


  const showModal = (event, val) => {
    console.log(event, val);

    event && event.preventDefault();
    setShow(val);
  };

  const setLoginValue = (data) => {
    setSignInVal({
      username: data?.username,
      email: data?.email,
      platform: 'Food-Delivery'
    });
  };

  const loginClicked = (data) => {
    // if (data.password && data.phone && !clLogin) {
    if (data.is_otp_verified && data.email && !clLogin) {
      setClogin(true);
    } else if (data.password && data.username && !clLogin) {
      props.loginUser(data, true);
      setClogin(true);
    }
  };

  const CloseloggedIn = () => {
    setShow(null);
  };

  const logoutFunction = () => {
    setLogin(false);
    setShow(null);
    props.logoutUser();

    if (!localStorage.headers) {
      // localStorage.removeItem("login");
      // localStorage.removeItem("cart");

      props.ClearState();
      props.updateCart(null);
    }
  };

  const showSignup = (event, key) => {
    event.preventDefault();
    setSignup(key);
  };
  const setSignupValue = (data) => {
    setSignupVal(data);
  };

  const SignUPclose = () => {
    setSignup(null);

    {/*if (localStorage.order_id) {
      setShowTrackOrder(true);
    }*/}

    console.log("Sign up close");
  };
  const showTrackOrderNowFunction = () => {
    setShowTrackOrder(false);
    setShowTracknow(true);
  };
  const trackOrderPage = () => {
    setShowTracknow(true);
    if (localStorage.order_id) {
      var order_id = localStorage.order_id;
      localStorage.removeItem("order_id");
      setShowTracknow(false);
      history.push("/track-order/" + order_id);
    }
  };

  const handleLocationSelect = (id, index) => {
    if (String(id) !== localStorage.getItem("location_id")) {
      setSelectedIndex(index);
      const params = new URLSearchParams(window.location.search);
      const businessId = params.get("business_id") || localStorage.getItem("business_id");
      history.push(`/?business_id=${businessId}&location_id=${id}`);
      window.location.reload();
    }
  };

  useEffect(() => {
    if (location_label) {
      const params = new URLSearchParams(window.location.search);
      const businessId = params.get("business_id");
      if (businessId) {
        history.push(`/?business_id=${businessId}&location_id=${location_label?.id}`);
      }
    }
  }, [location_label]);

  return (
    <>
      {/* {props.loading && <Spinner />} */}
      {props.resetPasswordLoading && <Spinner />}
      <header className={`page-header ${scrolled ? "scrolled" : ""}`}>
        <MenuModal show={showMenu} closeModal={() => setShowMenu(false)} />

        <Step1
          show={show === 1 ? true : false}
          closeModal={() => setShow(null)}
          showNext={(event) => showModal(event, 2)}
        />
        <Step2
          key={`step2-${show}`}
          show={show === 2 ? true : false}
          setShow={setShow}
          setSignup={setSignup}
          closeModal={() => setShow(null)}
          signInVal={signInVal}
          setLoginValue={setLoginValue}
        // showNext={(event) => showModal(event, 3)}
        />
        <Step3
          key={`step3-${show}`}
          signInVal={signInVal}
          loginClicked={loginClicked}
          setLoginValue={setLoginValue}
          show={(show === 3 ? true : false) && !localStorage.headers}
          closeModal={() => {
            CloseloggedIn();
            if (signInVal) { props.ClearState(); }
          }}
          goBack={() => {
            props.ClearState();
            setShow(2);
          }}
          auth={props.auth}              // ✅ Add this
          ClearState={props.ClearState}  // ✅ Add this
        />


        <Signup
          show={signup === 1 ? true : false}
          // closeModal={() => setSignup(null)}
          nextStep={() => setSignup(2)}
          setSignup={setSignupValue}
          signupVal={signupVal}
          closeModal={() => {
            setSignup(null);
            if (signInVal) { props.ClearState(); }
          }}
        />
        <Signup2
          show={signup === 2 ? true : false}
          // closeModal={() => SignUPclose(null)}
          setSignup={setSignupValue}
          previousStep={() => setSignup(1)}
          signupVal={signupVal}
          business_id={business_id}
          location_id={location_id}
          closeModal={() => {
            SignUPclose(null);
            if (signInVal) { props.ClearState(); }
          }}
        />
        <TrackOrder
          show={showtrackOrder}
          closeModal={() => setShowTrackOrder(false)}
          trackOrderNow={() => showTrackOrderNowFunction()}
        />

        <TrackOrderNow
          show={showTrackNow}
          closeModal={() => setShowTracknow(false)}
          trackOrder={() => trackOrderPage()}
        />

        <VerifiedEmail
          show={showVerifiedEmail}
          closeModal={() => setShowVerifiedEmail(false)}
        />

        <div className="is">
          <div className="left-section">
            <div className="home-link" style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
              {
                localStorage.business_id != null && localStorage.location_id != null
                  ? <Link disabled={true} to={'/?business_id=' + localStorage.business_id + '&location_id=' + localStorage.location_id}>
                    {
                      props?.business_details?.[0]?.logo ?
                        <img className="logo_align" src={props?.business_details?.[0]?.logo} alt="Home" />
                        :
                        <h3>{props?.business_details?.[0]?.name}</h3>
                    }
                  </Link>
                  : <Link disabled={true} to={'/'}> <TiHome size={30} /> </Link>
              }
              {localStorage.business_id != null && localStorage.location_id != null && location_label?.label && currentPath.pathname !== "/" && (
                <span className="header-location-name">{location_label.label}</span>
              )}
              {/*  <div style={{ position: 'relative', display: 'inline-flex', alignItems: 'center' }}>
                <div
                  onClick={() => setShowDropdown(!showDropdown)}
                  style={{
                    display: 'inline-block',
                    cursor: 'pointer',
                    marginLeft: '1px',
                    verticalAlign: 'middle',
                    position: 'relative',
                  }}
                >

                  {showDropdown && (
                    <div
                      style={{
                        marginTop: "25px",
                        position: 'absolute',
                        top: 'calc(100% + 4px)',
                        left: '0',
                        backgroundColor: '#1a1a1a',
                        border: '1px solid #333',
                        zIndex: 1000,
                        borderRadius: '6px',
                        boxShadow: '0 8px 24px rgba(0, 0, 0, 0.4)',
                        minWidth: '140px',
                        overflow: 'auto',
                      }}
                    >
                      {all_locations?.length > 0 &&
                        all_locations?.map((item, index) => (
                          <p
                            key={index}
                            onClick={() => handleLocationSelect(item.id, index, item.label)}
                            style={{
                              margin: 0,
                              padding: '8px 15px',
                              color: 'white',
                              backgroundColor: selectedIndex === index ? '#c21010f1' : 'transparent',
                              fontWeight: selectedIndex === index ? '600' : '400',
                              cursor: 'pointer',
                              transition: 'all 0.2s',
                              fontSize: '16px',
                              borderBottom:
                                index !== all_locations.length - 1
                                  ? '1px solid #333'
                                  : 'none',
                            }}
                          >
                            {item.label}
                          </p>
                        ))}
                    </div>
                  )}
                  <div style={{ color: "white", cursor: "pointer", fontWeight: "450" }} onClick={() => setShowDropdown(!showDropdown)}>{location_label?.label}
                    <span> {showDropdown ? (
                      <RiArrowDropUpFill style={{ fontSize: '24px', marginLeft: '1px', color: "#f0f0f0" }} />
                    ) : (
                      <RiArrowDropDownFill style={{ fontSize: '24px', marginLeft: '1px', color: "#f0f0f0" }} />
                    )}</span>
                  </div>
                </div>
              </div> */}
            </div>
          </div>
          <div className="right-section">
            {isLoggedIn && localStorage.business_id != null && localStorage.location_id != null ? (
              <div>
                <Dropdown as={ButtonGroup} className="ml-2 logged-user">
                  <Dropdown.Toggle
                    id="dropdown-custom-1"
                    className="bg-transparent border-0 d-flex align-items-center logged-user-toggle"
                  >
                    {photo ? (
                      <img
                        src={photo}
                        className="user-photo mr-2"
                        alt="Profile"
                        onError={() => setPhoto("")}
                      />
                    ) : (
                      <img src={user} className="user-icon mr-2" alt="user" />
                    )}
                    <span className="username">{name && name}</span>
                  </Dropdown.Toggle>
                  <Dropdown.Menu renderOnMount align="end" className="main-menu permanent-menu">
                    <Dropdown.Item
                      onClick={() => history.push("/account")}
                      eventKey="1"
                      className="border-bottom desktop-only"
                    >
                      Account
                    </Dropdown.Item>
                    <Dropdown.Item
                      eventKey="2"
                      className="border-bottom desktop-only"
                      onClick={() => history.push("/track-order")}
                    >
                      Track Order
                    </Dropdown.Item>
                    <Dropdown.Item
                      eventKey="3"
                      className="border-bottom desktop-only"
                      onClick={() => history.push("/order-history")}
                    >
                      Order History
                    </Dropdown.Item>
                    <Dropdown.Item as="div" eventKey="4"  className="signout-item d-flex align-items-center"
                      onClick={() => setShowLogoutConfirm(true)}
                      style={{
                        fontSize: "18px",
                        padding: "10px 16px",
                        fontWeight: "600",
                        color: "#fff"
                      }}
                    >
                      <FiLogOut
                        size={20}
                        style={{ marginRight: "8px", color: "#fff" }}
                      />
                      <span>Sign out</span>
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
              </div>
            ) : (

              // [(localStorage.business_id!=null && localStorage.location_id!=null ?
              <li className="credential">
                <div href={null} className="cursor">
                  {/* <span
                      ref={props.loginRef}
                      onClick={(event) => showModal(event, 1)}
                    >
                      Log in
                    </span>
                    /
                    <span
                      ref={props.regRef}
                      onClick={(event) => showSignup(event, 1)}
                    >
                      {" "}
                      Sign up
                    </span>
                    <img src={logout} className="ml-2" alt="" /> */}
                  <span
                    ref={props.loginRef}
                    onClick={(event) => showModal(event, 2)}
                    data-testid="user_sign_in"
                  >
                    Log in / Sign up
                    <img src={logout} alt="" />
                  </span>
                </div>
              </li>

              // : "")]
            )}

            {
              // localStorage.business_id!=null && localStorage.location_id!=null ?
              isLoggedIn ?
                <li className="cart">
                  {/* {props.cartData && props.cartData.count > 0 ? (
                <span className="cart-count-badge">
                  {props.cartData.count && props.cartData.count}
                </span>
              ) : null} */}

                  <div className="d-none d-md-block">
                    {/* {cartData && cartData.count > 0 ? (
                  <span className="cart-count-badge">
                    {cartData.count && cartData.count}
                  </span>
                ) : null} */}
                    <div
                      className="app-data btn btn-outline-ligh"
                      app-data="myCart"
                      onClick={props.showRightBar}
                      data-testid="right_side_bar"
                    >
                      <div ref={cartIconRef} className="cart-icon">
                        <CartIcon count={cartData?.length || 0} size={45} variant="desktop-header" />
                      </div>

                    </div>
                  </div>
                </li>
                :
                <li className="cart">
                  <div className="d-none d-md-block">
                    <div
                      className="app-data btn btn-outline-ligh"
                      app-data="myCart"
                      onClick={(event) => showModal(event, 2)}
                      data-testid="right_side_bar"
                    >
                      <div ref={cartIconRef} className="cart-icon">
                        <CartIcon count={cartData?.length || 0} size={45} variant="desktop-header" />
                      </div>

                    </div>
                  </div>
                </li>

            }
          </div>
        </div>


        <div
          className={`menu-overlay ${props.showMobileHeader ? "open" : ""}`}
        ></div>
        <div className={`ins ${props.showMobileHeader ? "open" : ""}`}>
          <figure className="mb-4">
            <a href="/">
              {" "}
              <img src={logo} alt="logo" />{" "}
            </a>
          </figure>
          {isLoggedIn ? (
            <ul className="menu">
              <li>
                <a href="/" className="user">
                  <figure>
                    <img src="images/user-sm.svg" alt="" />
                  </figure>
                  <span> {name && name}</span>
                </a>
              </li>
              <li className="separator">
                <a href="/" onClick={logoutFunction}>
                  Sign Out
                </a>
              </li>
              <li>
                <a href="/track-order">Track Order</a>
              </li>
              <li>
                <a href="/order-history">Order History</a>
              </li>
            </ul>
          ) : (
            <ul className="menu">
              <li className="separator">
                <a href="/">
                  <span onClick={(event) => showModal(event, 1)}>Login</span>{" "}
                  &nbsp;/ &nbsp;
                  <span onClick={(event) => showSignup(event, 1)}>Sign up</span>
                </a>
              </li>
            </ul>
          )}
          <div className="bottom">
            <a href="/" className="language">
              <img src="images/globe.svg" alt="" /> English
            </a>
            <a href="/" className="close" onClick={props.showMobile}>
              <span aria-hidden="true">×</span>
            </a>
          </div>
        </div>
      </header>

      {/* Mobile floating cart button — outside <header> so it's not hidden by display:none on mobile */}
      {localStorage.business_id != null &&
        localStorage.location_id != null &&
        !(props.cashregister && props.cashregister.status === "closed") ? (
        <div className="d-block d-sm-none mycart-mb fixed-cart-mobile">
          {cartData && cartData.length > 0 ? (
            <div
              className="mobile-cart-btn-wrapper"
              app-data="myCart"
              onClick={(event) => {
                if (isLoggedIn) {
                  props.showRightBar();
                } else {
                  showModal(event, 2);
                }
              }}
            >
              <div ref={cartIconRef} className="mobile-cart-icon">
                <CartIcon count={cartData?.length || 0} size={50} />
              </div>
            </div>
          ) : (
            <div
              className="mobile-cart-btn-wrapper"
              app-data="myCart"
              onClick={(event) => {
                if (isLoggedIn) {
                  props.showRightBar();
                } else {
                  showModal(event, 2);
                }
              }}
            >
              <div ref={cartIconRef} className="mobile-cart-icon">
                <CartIcon count={cartData?.length || 0} size={50} />
              </div>
            </div>
          )}
        </div>
      ) : null}
      <div className="mobile-bottom-nav">
      <div
        className={`nav-item ${activeNavItem === 'home' ? 'active' : ''}`}
        onClick={() => {
          setActiveNavItem('home');
          const businessId = localStorage.getItem("business_id");
          const locationId = localStorage.getItem("location_id");

          if (businessId && locationId) {
            history.push(`/?business_id=${businessId}&location_id=${locationId}`);
          } else {
            history.push("/");
          }
        }}
      >
        <FaHome size={24} />
        <span>Home</span>
      </div>
        <div
          className={`nav-item ${activeNavItem === 'account' ? 'active' : ''}`}
          onClick={(event) => {
            setActiveNavItem('account');
            if (isLoggedIn) {
              history.push("/account");
            } else {
              showModal(event, 2);
            }
          }}
        >
          <MdAccountCircle size={24} />
          <span>Account</span>
        </div>

        <div
          className={`nav-item ${activeNavItem === 'track' ? 'active' : ''}`}
          onClick={(event) => {
            setActiveNavItem('track');
            if (isLoggedIn) {
              history.push("/track-order");
            } else {
              showModal(event, 2);
            }
          }}
        >
          <FaTruck size={22} />
          <span>Track</span>
        </div>

        <div
          className={`nav-item ${activeNavItem === 'orders' ? 'active' : ''}`}
          onClick={(event) => {
            setActiveNavItem('orders');
            if (isLoggedIn) {
              history.push("/order-history");
            } else {
              showModal(event, 2);
            }
          }}
        >
          <BiReceipt size={24} />
          <span>Orders</span>
        </div>

        <div
          className={`nav-item ${activeNavItem === 'cart' ? 'active' : ''}`}
          onClick={(event) => {
            setActiveNavItem('cart');
            if (isLoggedIn) {
              props.showRightBar();
            } else {
              showModal(event, 2);
            }
          }}
        >
          {/* <div className={`bottom-nav-cart-icon ${activeNavItem === 'cart' ? 'active' : ''}`}> */}
          <div className="bottom-nav-cart-icon">
            <div className="nav-cart-inner">
              <CartIcon count={cartData?.length || 0} size={22} />
            </div>
          </div>
          <span>Cart</span>
        </div>
      </div>

{/* SignOut Popup */}
    {showLogoutConfirm && (
      <div className="logout-modal-overlay">
        <div className="logout-card">
          <div className="logout-header">
            <div className="logout-icon">
              <FiLogOut size={28} />
            </div>

            <span
              className="close-btn"
              onClick={() => setShowLogoutConfirm(false)}
            >
              ✕
            </span>
          </div>

          <div className="logout-body">
            <p className="welcome-text">Are you sure?</p>
            <h2 className="username-text">Sign out from account</h2>
            <p className="sub-text">You will need to login again</p>

            <button
              className="logout-confirm-btn"
              onClick={() => {
                setShowLogoutConfirm(false);
                setMobileDropdown(false);
                logoutFunction();
              }}
            >
              Sign Out
            </button>
          </div>

        </div>
      </div>
    )}
    </>
  );
};

Header.propTypes = {
  showRightBar: PropTypes.func.isRequired,
  showMobile: PropTypes.func.isRequired,
  loginUser: PropTypes.func.isRequired,
  auth: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  errors: state.errors,
  add_to_cart: state.products.add_to_cart,
  loading: state.products.loading,
  resetPasswordLoading: state.user.loading,
  business_details: state?.products?.business_location,
  signup_login: state?.user?.signup,
  cashregister: state.products.cashregister,
});
export default withTranslation()(
  connect(mapStateToProps, {
    ClearState,
    cartLocal,
    logoutUser,
    // mycart,
    loginUser,
    locationLabel
  })(Header)
);
